// new image js to pick up the correct variant relationship

jQuery(function() {
jQuery('[name=id]').change(function() {
alert('You have selected ' + jQuery(this).find(":selected('option')").attr("title"));
 });
});



//jQuery('[name=id]').change(function() {
    // What is the sku of the current variant selection.
  //  var sku = jQuery(this).find(":selected('option')").attr("title"));
// Looking for the preloaded image which src attribute contains the sku.
    //var new_src = jQuery('#preload img[src*=' + sku + ']').attr('src');
// The main image will point to a larger version to showcase in the lightbox.
    //var new_href = new_src.replace('medium','large');
    // Updating the main image and the href attribute of the anchor element that wraps it.
    //jQuery('#main-product-image a').attr('href', new_href).find('img').attr('src', new_src);
// });
//});


